import { render, staticRenderFns } from "./SoftwareLink.vue?vue&type=template&id=cbfee7ca"
import script from "./SoftwareLink.vue?vue&type=script&lang=js"
export * from "./SoftwareLink.vue?vue&type=script&lang=js"
import style0 from "./SoftwareLink.vue?vue&type=style&index=0&id=cbfee7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports